module.exports = __webpack_public_path__ + "img/boat_driving.862d94d8.svg";